<template>
  <form-row
    v-if="singleOption"
    :is-vertical-splitted="false"
  >
    <validation-provider
      v-slot="{ failed }"
      rules="required"
      data-unit-test="partner-marketing-single-option"
      :name="`Partner Marketing Single Option ${capitalize(optionLabel)}`"
      :vid="`${stepId}_direct-marketing-${optionLabel.toLowerCase()}`"
    >
      <radio
        v-model="partnerMarketingChoice"
        :name="`partner-marketing-${optionLabel}`"
        :data-test="`partner_marketing_${snakeCase(optionLabel)}`"
        :items="constants.YES_NO"
        :error="failed"
        @change="(value) => changeOption(singleOption.field, value)"
      />
    </validation-provider>
  </form-row>

  <form-row
    v-else
    :is-vertical-splitted="false"
  >
    <marketing-options
      type="partner"
      :check-all-value="checkAllValue"
      :options-value="optionsValue"
      :options-list="partnerMarketingOptions"
      @change-option="({ option, value }) => changeOption(option, value)"
    />
  </form-row>
</template>

<script>
import MarketingOptions from '@/components/marketingOptions/MarketingOptions';
import { capitalize, snakeCase } from 'lodash';

export default {
  name: 'single-partner-marketing-option',
  components: {
    MarketingOptions,
  },
  inject: ['constants', 'config'],
  props: {
    stepId: {
      type: String,
      required: true,
    },
    optionsValue: {
      type: Object,
      required: true,
    },
    singleOption: {
      type: Object,
      default: null,
    },
  },
  data () {
    return {
      partnerMarketingChoice: null,
    };
  },
  mounted () {
    // Set on load of page
    this.partnerMarketingChoice = this.optionsValue[this.singleOption?.field];
  },
  setup () {
    return {
      capitalize,
      snakeCase,
    };
  },
  computed: {
    partnerMarketingOptions () {
      return this.config.partnerMarketingOptions || [];
    },
    checkAllValue () {
      return this.partnerMarketingOptions.every(field => this.optionsValue[this.constants.PARTNER_MARKETING_OPTIONS[field].field]);
    },
    optionLabel () {
      return this.singleOption.label;
    },
  },
  methods: {
    changeOption (option, value) {
      // Emit all the fields if Accept all is chosen.
      if (option === 'all') {
        const fields = this.partnerMarketingOptions.reduce((acc, currentVal) =>
          [...acc, this.constants.PARTNER_MARKETING_OPTIONS[currentVal].field], []);

        this.$emit('change-option', { fields, value });

        return;
      }

      // Emit one option
      this.$emit('change-option', { option, value });
    },
  },
};
</script>
